import React from "react";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";

import { Icon } from "../../Icon";
import { Icons } from "../../Icon/types";

interface AttachFileProps {
  onClick: () => void
}

const AttachFileButton: React.ReactFCWithChildren<AttachFileProps> = ({ onClick }) => {
  return (
    <>
      <Button
        data-tip="Click here to add files to response or drag and drop files into text box."
        onClick={onClick}
      >
        <Icon
          icon={Icons.ATTACH}
          $fillColor="darkGrey"
          size={20}
        />
      </Button>

      <ReactTooltip place="bottom" />
    </>
  );
};

const Button = styled.div`
  padding: 5px;
  display: flex;
  align-items: center;
  
  :hover {
    border-bottom: 1px solid lightGray;
    border-right: 1px solid lightGray;
    padding: 5px 4px 4px 5px;
    cursor: pointer;
  }
  
  :active {
    border-top: 1px solid lightGray;
    border-left: 1px solid lightGray;
    border-bottom: 0px;
    border-right: 0px;
    padding: 4px 5px 5px 4px;
  }
`;

export default AttachFileButton;
